{
  "a": "una",
  "an": "un",
  "Account": "Cuenta",
  "AccountSettings": "Ajustes de Cuenta",
  "changeAccountSettings": "Cambia tus ajustes básicos",
  "notVerified": "Sin verificar",
  "Verified": "Verificado",
  "AlternateEmail": "Email alternativo",
  "NoAlternateEmail": "No tienes emails alternativos.",
  "changeRole": "Cambiar rol",
  "LeaveProject": "Dejar proyecto",
  "NoActionPhrase1": "No hay ninguna acción que puedas realizar por sí mismo. Para realizar modificaciones, consulta tu",
  "accountSettings": "ajustes de cuenta",
  "NoActionPhrase2": "No hay ninguna acción para realizar ",
  "save": "Guardar",
  "Title": "Título",
  "editTitle": "editar título",
  "DangerZone": "Zona peligrosa",
  "Delete": "Eliminar ",
  "DeleteWarning": "Una vez que elimines este proyecto, NO hay vuelta atrás. Por favor, asegúrate",
  "DeleteProjectButton": "Eliminar este proyecto",
  "Hub": "Hub",
  "Project": "Proyecto",
  "ManageTeam": "Dirigir equipo",
  "Team": "Equipo",
  "ManageTeamPhrase1Part1": "Eres ",
  "ManageTeamPhrase1Part2": "de este proyecto",
  "ManageTeamPhrase2Part1": "Para agregar un miembro del equipo, ",
  "clickHere": " haz clic aquí",
  "PendingInvitations": "Invitaciones pendientes",
  "resendInvite": "Reenviar invitación",
  "NoPendingInvitations": "Sin invitacion pendientes",
  "Primary": "Principal",
  "verify": "Verificar",
  "MakePrimary": "hacer principal",
  "remove": "Eliminar",
  "EmailAddress": "Dirección de correo electrónico",
  "addEmail": "Agregar correo electrónico",
  "addHubAdmin": "Para añadir a un administrador de hub,",
  "ProjectNameAlreadyExists": "Oh vaya! Este nombre de proyecto ya está en uso. Seleccione otro nombre. Bueno, ¡es otra oportunidad para ser creativo!",
  "ConfirmProjectDeletion": "¿Estás seguro de que deseas eliminar este Proyecto?",
  "SubscriptionExpired": "¡Esta suscripción ha caducado!",
  "SubscriptionExpiredMessage": "Tu acceso al hub ahora es limitado. Por favor renueve poniéndose en contacto con nosotros.",
  "FirstChoice": "Contacta con nosotros",
  "Cancel": "Cancelar",
  "firstName": "Nombre",
  "lastName": "Apellidos",
  "Purpose": "Propósito",
  "Location": "Ubicación",
  "LocationPlaceholder": "Busca tu ciudad aquí",
  "Stage": "Etapa",
  "Seed": "Semilla",
  "Planning": "Planificación",
  "Startup": "Puesta en marcha",
  "Growth": "Crecimiento",
  "Mature": "Maduro",
  "noTitle": "Sin título todavía",
  "Name": "Nombre",
  "Role": "Rol",
  "DeleteAccountHeading": "Eliminar tu cuenta",
  "DeleteAccountButton": "Eliminar cuenta",
  "DeleteAccountWarning": "Al eliminar tu cuenta se cerrará tu sesión en todos los dispositivos de inmediato. Después de 30 días borraremos permanentemente tu información personal: tu nombre, direcciones de correo, perfil, imágenes subidas y registros de actividad. Esto no se puede deshacer.",
  "DeleteAccountDialogTitle": "¿Eliminar tu cuenta?",
  "DeleteAccountDialogWarning": "Tu cuenta se desactivará de inmediato y se borrará permanentemente después de 30 días. Escribe a support@rebelbase.co antes de esa fecha si cambias de opinión.",
  "DeleteAccountConfirmPrompt": "Escribe {{confirmation}} para confirmar.",
  "DeleteAccountConfirmButton": "Eliminar mi cuenta",
  "DeleteAccountError": "No pudimos procesar la solicitud. Inténtalo de nuevo o escribe a support@rebelbase.co.",
  "Profile": "Perfil",
  "NameRequired": "Este campo es obligatorio."
}
